/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpful_Quiet_Turkey_ScoopInputs */

const fr_helpful_quiet_turkey_scoop = /** @type {(inputs: Helpful_Quiet_Turkey_ScoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'abonnement a été modifié`)
};

/**

* @param {Helpful_Quiet_Turkey_ScoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const helpful_quiet_turkey_scoop = /** @type {((inputs?: Helpful_Quiet_Turkey_ScoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpful_Quiet_Turkey_ScoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_helpful_quiet_turkey_scoop(inputs)
});